module.exports = __webpack_public_path__ + "img/leadgrease_black.3c874abd.png";